import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
  .set('GetReassignment', new Immutable.Map({tareas: {tarea: []}}))

/*Types*/

export const ACTION_GET_REASSIGNMENT = 'ACTION_GET_REASSIGNMENT'

/*Reducer*/

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_GET_REASSIGNMENT:
      return state.set('GetReassignment', new Immutable.Map(action.Obj))
    default:
      return state
  }
}

/*Action Creators*/

export const getReassignment = () => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getReassignment',
      method: 'POST',
      data: { usuarioReasignado: sessionStorage.uid },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_REASSIGNMENT, Obj: !response.data.tareas ? {tareas: {tarea: []}} : response.data })
        return response
      }).catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const clearReassignment = () => {

  return (dispatch) => {
    dispatch({ type: ACTION_GET_REASSIGNMENT, Obj: {tareas: {tarea: []}}})
  }
}



// WEBPACK FOOTER //
// ./src/modules/Reassignment/index.js